var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c_element_upload_img"},[_c('el-upload',{attrs:{"id":_vm.idNum,"action":"","http-request":_vm.uploadFile,"show-file-list":false,"before-upload":_vm.beforeUpload,"accept":_vm.uploadAccept}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }